module.exports = __webpack_public_path__ + "img/epr@2x.deb8f145.jpeg";